@import '../../utils/control-density.css';
@import '../../utils/key-hint.css';
@import '../../utils/forced-colors.css';

.tooltip-popup {
  box-sizing: border-box;
  background-color: var(--color-background-primary);
  border-radius: var(--ds-control-radius, var(--dimension-radius-025));
  box-shadow: var(--effect-elevation-elevated-floating);
  white-space: nowrap;
  pointer-events: none;
  animation: tooltipFadeIn var(--effect-motion-short-2) forwards;
  will-change: transform;
  backface-visibility: hidden;
}

/* Warm handoff between nearby triggers — no enter fade (avoids 20–100ms lag). */
.tooltip-popup--instant {
  animation: none;
  opacity: 1;
}

.tooltip-popup--closing {
  animation: tooltipFadeOut var(--effect-motion-short-3) forwards;
}

/* Density: md / sm / xs via `.ds-control--*` on `.tooltip-inner`. */
.tooltip-inner {
  box-sizing: border-box;
  height: var(--ds-control-height, var(--dimension-size-400));
  display: flex;
  align-items: center;
  gap: var(--ds-control-gap, var(--dimension-space-050));
  padding: 0 var(--ds-control-padding-inline, var(--dimension-space-075));
}

/*
 * Label layout lives on ds-text (metric-box + control label-inset).
 * NOTE: Stencil scopes this to `ds-text.sc-ds-tooltip`, but portaled
 * createElement ds-text loses that class when Text's <Host class> renders.
 * `renderPopupContent` therefore also sets these as inline styles.
 */
.tooltip-inner > ds-text {
  flex-shrink: 0;
  min-width: max-content;
  max-width: none;
  padding: 0 var(--ds-control-label-inset, var(--dimension-space-025));
  color: var(--color-foreground-primary);
}

.tooltip-popup--wrap {
  white-space: normal;
  max-inline-size: var(--dimension-panel-width-xs);
}

.tooltip-popup--wrap .tooltip-inner {
  height: auto;
  min-height: var(--ds-control-height, var(--dimension-size-400));
  padding-block: var(--dimension-space-050);
  align-items: flex-start;
}

.tooltip-popup--wrap .tooltip-inner > ds-text {
  flex: 1 1 auto;
  min-width: 0;
  max-width: 100%;
  white-space: normal;
}

@keyframes tooltipFadeIn {
  from { opacity: 0; }
  to   { opacity: 1; }
}

@keyframes tooltipFadeOut {
  from { opacity: 1; }
  to   { opacity: 0; }
}

@media (prefers-reduced-motion: reduce) {
  .tooltip-popup,
  .tooltip-popup--instant {
    animation: none;
    opacity: 1;
  }

  .tooltip-popup--closing {
    animation: none;
    opacity: 0;
  }
}

@media (forced-colors: active) {
  .tooltip-popup {
    box-shadow: none;
    outline: var(--dimension-stroke-width-012) solid var(--ds-forced-color-content);
    outline-offset: calc(-1 * var(--dimension-stroke-width-012));
  }
}
